import { call, put, takeLatest } from "redux-saga/effects";
import { UserProfileActions, GET_USER_PROFILE } from "@redux/reducer";
import {
  StylehintListUgcPayload,
  StylehintListUgcResponse,
  STYLING_SORT_BY,
  UserProfilePayload
} from "@type/index";
import request from "@util/net/request";
import axios, { AxiosResponse } from "axios";
import {
  isFromInstagram,
  StylehintNormalQuery
} from "@util/net/queryParameters";

export function* getUserProfileSaga(action: { payload: UserProfilePayload }) {
  try {
    const payload: UserProfilePayload = action.payload;
    const _payload: StylehintListUgcPayload = StylehintNormalQuery(payload);
    yield put(UserProfileActions.setUserProfileNotFound(""));
    yield put(UserProfileActions.getUserProfileLoading(true));
    const res: AxiosResponse<StylehintListUgcResponse> = yield call(
      request.get,
      "/contents/search",
      {
        params: {
          ..._payload,
          order: STYLING_SORT_BY.PUBLISHED_AT_DESC
        }
      }
    );
    if (res.status !== 200) {
      yield put(UserProfileActions.setUserProfileNotFound("503"));
    } else if (
      res.data.content_list &&
      res.data.content_list.length > 0 &&
      ((!isFromInstagram(res.data.content_list[0].author?.image_source) &&
        res.data.content_list[0].author?.nick_name === "") ||
        (isFromInstagram(res.data.content_list[0].author?.image_source) &&
          res.data.content_list[0].author?.user_name === ""))
    ) {
      yield put(UserProfileActions.setUserProfileNotFound("404"));
    } else if (res.data.content_list && res.data.content_list.length > 0) {
      yield put(UserProfileActions.getUserProfileSuccess(res.data));
    } else {
      yield put(UserProfileActions.setUserProfileNotFound("404"));
    }
  } catch (error) {
    if (!axios.isCancel(error)) {
      yield put(UserProfileActions.setUserProfileNotFound("503"));
    }
  }
}

export function* watchLoadUserProfileSaga() {
  yield takeLatest<any>(GET_USER_PROFILE, getUserProfileSaga);
}
